<template>
  <div class="container-fluid">
    <!-- Content Header (Page header) -->
    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-12">
          <div class="box box-info">
            <div class="box-header with-border">
              
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-md-3">
                  <label
                    >Date <span class="red">*</span></label
                  >
                  <input
                    v-model="emiDate"
                    type="date"
                    @change="loadAgentMember"
                    name="emiDate"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('emiDate'),
                    }"
                    required
                  />
                  <has-error
                    :form="form"
                    field="emiDate"
                  ></has-error>
                </div>
                <div class="col-md-3">
                  <label for="Branch">Branch</label>
                  <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="getBranchRecord"></v-select>
                  
                  <has-error
                    :form="form"
                    field="branch_id"
                  ></has-error>
                </div>
                <div class="col-md-3">
                  <label for="Branch">Group</label>
                  <v-select v-model="colC"  name="collection_center_id" label="name" :options="collectionCenters" placeholder="Select Group" v-on:input="loadAgentMember" required></v-select>
                  <has-error
                    :form="form"
                    field="branch_id"
                  ></has-error>
                </div>
                <div class="col-md-3" v-if="colC.name">
                  <br>
                  <span>
                    <button class="btn btn-primary" @click="printView">Get Print</button>
                  </span>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
          <div class="box box-success">
            <div class="box-body">
              <div class="card">
                <div class="card-header">
                  <span class="pull-right">
                    <strong>Total Current Due : {{totalAmt}}</strong>
                  </span>
                  <h3 class="card-title">Member List</h3>
                  
                </div>
                <!-- /.card-header -->
                <div class="card-body table-sm">
                  <vue-good-table
                    :columns="columnsAgentMemberRecords"
                    :rows="rowsAgentMemberRecords"
                    styleClass="vgt-table condensed"
                    :line-numbers="true"
                    :pagination-options="{
                      enabled: true,
                      perPage: 10,
                      perPageDropdown: [10, 20, 30],
                    }"
                    :search-options="{
                      enabled: true,
                      trigger: 'enter',
                    }"
                  >
                    <template slot="table-row" slot-scope="props">
                      
                      <span v-if="props.column.field == 'EmiDate'">
                        {{props.row.emiDate | myDate}}
                      </span>
                      <span v-if="props.column.field == 'Status'">
                        <span
                          v-if="props.row.status == 'pending'"
                          class="label label-warning"
                          >Pending</span
                        >
                        <span
                          v-if="props.row.status == 'paid'"
                          class="label label-success"
                          >Paid</span
                        >
                        <span
                          v-if="props.row.status == 'partial'"
                          class="label label-info"
                          >Partial</span
                        >
                      </span>
                      <span v-if="props.column.field == 'action'">
                        <button v-if="props.row.arrear > 0 && props.row.member_collection_pending.length <= 0"
                          @click="newModal(props.row)"
                          class="btn btn-success btn-xs"
                          >Collect Payment
                        </button>
                        <div v-else-if="props.row.member_collection_pending.length > 0" class="text-warning">Pending</div>
                        <div v-else class="text-success">Paid</div>
                      </span>
                      
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
            </div>
          </div>
          <!-- /.card -->
          <div class="box box-success">
            <div class="box-body">
              <div class="card">
                <div class="card-header">
                  <span class="pull-right">
                    
                  </span>
                  <h3 class="card-title">Member Collection</h3>
                  
                </div>
                <!-- /.card-header -->
                <div class="card-body table-sm">
                  <vue-good-table
                    :columns="columnsMemberCollections"
                    :rows="rowsMemberCollections"
                    styleClass="vgt-table condensed"
                    :pagination-options="{
                      enabled: true,
                      perPage: 10,
                      perPageDropdown: [10, 20, 30],
                    }"
                    :search-options="{
                      enabled: true,
                      trigger: 'enter',
                    }"
                  >
                    <template slot="table-row" slot-scope="props">
                      
                      
                      <span v-if="props.column.field == 'Status'">
                        <span
                          v-if="props.row.status == 'pending'"
                          class="label label-warning"
                          >Pending</span
                        >
                        <span
                          v-if="props.row.status == 'paid'"
                          class="label label-success"
                          >Paid</span
                        >
                        <span
                          v-if="props.row.status == 'partial'"
                          class="label label-info"
                          >Partial</span
                        >
                      </span>
                      
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
            </div>
          </div>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
      <div class="modal fade" id="newModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 v-show="!editMode" class="modal-title">Payment Collection</h4>
            </div>
            <form @submit.prevent="collectPayment()">
              <div class="modal-body">
                <!-- right column -->
                
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Amount <span class="red">*</span></label>
                            <input
                              v-model="form.amt"
                              type="text"
                              name="amt"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('amt') }"
                              required
                            />
                            <has-error :form="form" field="amt"></has-error>
                          </div>
                          <!-- <div class="form-group">
                            <label
                              >Payment Mode <span class="red">*</span></label
                            >
                            <select
                              v-model="form.paymentMode"
                              name="paymentMode"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('paymentMode'),
                              }"
                              required
                            >
                              <option
                                v-if="!form.paymentMode"
                                selected
                                value=""
                              >
                                Select Payment Mode
                              </option>
                              <option value="bank">Bank</option>
                              <option value="cash">Cash</option>
                            </select>
                            <has-error
                              :form="form"
                              field="paymentMode"
                            ></has-error>
                          </div>

                          <div
                            class="form-group"
                            v-if="form.paymentMode == 'bank'"
                          >
                            <label>Select Bank </label>
                            <select
                              v-model="form.bank_id"
                              name="bank_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('bank_id'),
                              }"
                            >
                              <option v-if="!form.bank_id" selected value="">
                                Select Bank
                              </option>
                              <option
                                :value="ban.id"
                                v-for="ban in banks"
                                :key="ban.id"
                              >
                                {{ ban.name }}
                              </option>
                            </select>
                            <has-error :form="form" field="bank_id"></has-error>
                          </div> -->

                          <div class="form-group">
                            <label>Select Ledger Account </label>
                            <select
                              v-model="form.branch_ledger_id"
                              name="branch_ledger_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_ledger_id'),
                              }"
                            >
                              <option v-if="!form.branch_ledger_id" selected value="">
                                Select Ledger Account
                              </option>
                              <option
                                :value="bank_account.id"
                                v-for="bank_account in bank_accounts"
                                :key="bank_account.id"
                              >
                                {{bank_account.name}} {{bank_account.remark}}
                              </option>
                            </select>
                            <has-error :form="form" field="branch_ledger_id"></has-error>
                          </div>
                          <div class="form-group">
                            <label
                              >Payment Date <span class="red">*</span></label
                            >
                            <input
                              v-model="form.paymentDate"
                              type="date"
                              name="paymentDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('paymentDate'),
                              }"
                              required
                            />
                            <has-error
                              :form="form"
                              field="paymentDate"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label
                              >Attendance <span class="red">*</span></label
                            >
                            <select
                              v-model="form.attendance"
                              name="attendance"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('attendance'),
                              }"
                            >
                              <option selected value="present">Present</option>
                              <option value="absent">Absent</option>
                            </select>
                            <has-error :form="form" field="attendance"></has-error>
                          </div>
                          <div class="form-group">
                            <label>Remark </label>
                            <input
                              v-model="form.remark"
                              type="text"
                              name="remark"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('remark') }"
                            />
                            <has-error :form="form" field="remark"></has-error>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="box box-default" v-if="memberloanplan.member">
                            <div class="box-header with-border">
                              <i class="fa fa-bullhorn"></i> 
                              <h3 class="box-title">Customer Details</h3>
                            </div> 
                            <div class="box-body">
                              
                              <div class="text-center">
                                <img
                                  class="profile-user-img img-fluid img-circle"
                                  :src= this.photo
                                  alt="User profile picture"
                                />
                              </div>
                              <div class="callout callout-info">
                                <h4>Member</h4>
                                <p>{{memberloanplan.member.name}}</p>
                                <h4>Mobile No</h4>
                                <p>{{memberloanplan.member.mobile}}</p>
                                <h4>Address</h4>
                                <p v-if="memberRecord">{{memberRecord.address}}</p>
                              </div> 
                              <div class="callout callout-danger" v-if="memberloanplan.collection_center">
                                <h4>Group</h4>
                                <p>{{memberloanplan.collection_center.name}}</p>
                              </div>
                            </div>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
               
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                >
                  CREATE
                </button>
                
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>

      <!-- /.modal -->
      <div class="modal fade" id="printView">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
                <button @click="printAgentCollectionList()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
            </div>
            <div class="modal-body" id="printAgentCollectionList">
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="getCompanyRecord"> 
                      <table class="table table-condensed">
                        <thead>
                          <!-- <td><img :src="logo" height="100"></td> -->
                          <td><strong>Group Detail</strong> <br>Name - {{colC.name}}<br> 
                            Address: {{colC.address}}<br>
                            branch: {{branch.name}}
                          </td>
                          <td class="text-right"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br> Website - {{getCompanyRecord.url}}
                            </small></h4></td>
                        </thead>
                      </table>
                      <hr width="100%">
                      <h3>Customer EMI Records </h3>
                      <p class="text-right"><strong>Total Amount : {{totalAmt}}</strong></p>
                      <table class="table table-condensed">
                        <thead>
                          <tr>
                            <td>Sr No.</td>
                            <td><strong>Mem Code</strong></td>
                            <td><strong>Member</strong></td>
                            <td><strong>(C/O) ALIAS</strong></td>
                            <td><strong>Mob No</strong></td>
                            <td><strong>Loan No</strong></td>
                            <td><strong>EMI Date</strong></td>
                            <td><strong>EMI No</strong></td>
                            <td><strong>Curr Due</strong></td>
                            <td><strong>EMI</strong></td>
                            <td><strong>Collection Amt</strong></td>
                          </tr>
                        </thead>
                        <tbody style="border-width:2px; color:black; border-style:solid;" v-if="rowsAgentMemberRecords">
                          <tr v-for="(rowsAgentMemberRecord,index) in rowsAgentMemberRecords" :key="rowsAgentMemberRecord.id" style="border-width:2px;border-style:solid;">
                            <td>{{index+1}}</td>
                            <td><span v-if="rowsAgentMemberRecord.member">{{rowsAgentMemberRecord.member.code}}</span></td>
                            <td><span v-if="rowsAgentMemberRecord.member">{{rowsAgentMemberRecord.member.name}}</span></td>
                            <td><span v-if="rowsAgentMemberRecord.member">{{rowsAgentMemberRecord.member.alias}}</span></td>
                            <td><span v-if="rowsAgentMemberRecord.member">{{rowsAgentMemberRecord.member.mobile}}</span></td>
                            <td><span v-if="rowsAgentMemberRecord.member_loan_plan">{{rowsAgentMemberRecord.member_loan_plan.applicationNo}}</span></td>
                            <td><span v-if="rowsAgentMemberRecord">{{rowsAgentMemberRecord.emiDate}}</span></td>
                            <td><span v-if="rowsAgentMemberRecord">{{rowsAgentMemberRecord.emiNo}}</span></td>
                            <td><span v-if="rowsAgentMemberRecord">{{rowsAgentMemberRecord.arrear}}</span></td>
                            <td><span v-if="rowsAgentMemberRecord">{{rowsAgentMemberRecord.total}}</span></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                >
                  CREATE
                </button>
                
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
var _ = require('lodash')
import { mapState } from 'vuex'
import GetBranch from '../../mixins/BranchRecords'
export default {
  name: 'GroupEmiCollection',
  mixins: [GetBranch],
  computed: {
    ...mapState([
      'user'
    ])
  },
  data () {
    return {
      editMode: false,
      photo: this.$store.state.imageDefaultUrl + '150',
      logo: '',
      colC: {},
      memberLoan: {},
      emiDate: new Date().toISOString().slice(0, 10),
      collectionCenters: [],
      collectionCenter: {
        name: 'Select Group'
      },
      memberRecord: [],
      designations: [],
      designation: {},
      applicationNumber: '',
      memberCode: '',
      mobileNumber: '',
      adharCardNumber: '',
      pancardNumber: '',
      branches: [],
      branch: {},
      members: {},
      staffs: [],
      staff: {},
      banks: {},
      pl: {},
      totalAmt: 0,
      seeRecord: {},
      loanplans: [],
      printData: [],
      memberloanplans: [],
      memberloanplan: {},
      groupMembers: {},
      bank_accounts: [],
      loadDisbursements: {},
      getCompanyRecord: {},
      viewCollectionCenter: '',
      form: new Form({
        id: '',
        collection_center_id: '',
        member_loan_plan_id: null,
        branch_id: '',
        agent_id: '',
        center_leader_id: '',
        plan_id: '',
        amt: '',
        type: 'emi',
        plan: {},
        planType: '',
        member_id: '',
        designation_id: '',
        attendance: 'present',
        date: '',
        remark: '',
        status: '',
        disbursement_id: '',
        branch_ledger_id: '',
        paymentDate: new Date().toISOString().slice(0, 10),
        emiStartDate: ''
      }),
      columns: [
        {
          label: 'EMI DATE',
          field: 'emiDate'
        },
        {
          label: 'PRINCIPAL',
          field: 'principal'
        },
        {
          label: 'INTEREST',
          field: 'intrest'
        },
        {
          label: 'TOTAL',
          field: 'total'
        },
        {
          label: 'ADJUSTMENT',
          field: 'adjustment'
        },
        {
          label: 'BALANCE',
          field: 'balance'
        },
        {
          label: 'RECEIVED',
          field: 'received'
        },
        {
          label: 'ARRIER',
          field: 'arrear'
        },
        {
          label: 'ADVANCE',
          field: 'advance'
        },
        {
          label: 'STATUS',
          field: 'Status'
        }
      ],
      rows: [],
      columnsMemberCollections: [
        {
          label: 'PAYMENT DATE',
          field: 'paymentDate'
        },
        {
          label: 'AMOUNT',
          field: 'amt'
        },
        {
          label: 'RECEIVED BY',
          field: 'received_by.name'
        },
        {
          label: 'PAYMENT MODE',
          field: 'branch_ledger.ledger.name'
        },
        {
          label: 'STATUS',
          field: 'Status'
        }
      ],
      rowsMemberCollections: [],
      columnsAgentMemberRecords: [
        {
          label: 'MEMBER CODE',
          field: 'member.code'
        },
        {
          label: 'MEMBER',
          field: 'member.name'
        },
        {
          label: '(C/O) ALIAS',
          field: 'member.alias'
        },
        {
          label: 'MEMBER MOB',
          field: 'member.mobile'
        },
        {
          label: 'LOAN APPLICATION NUMBER',
          field: 'member_loan_plan.applicationNo'
        },
        {
          label: 'EMI DATE',
          field: 'EmiDate'
        },
        {
          label: 'EMI NUMBER',
          field: 'emiNo'
        },
        {
          label: 'ADVANCE',
          field: 'advance'
        },
        {
          label: 'CURRENT DUE',
          field: 'arrear'
        },
        {
          label: 'EMI',
          field: 'total'
        },
        {
          label: 'ACTION',
          field: 'action'
        }
      ],
      rowsAgentMemberRecords: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    newModal (row) {
      this.form.test = row
      this.form.branch_id = row.branch_id
      this.form.member_loan_plan_id = row.member_loan_plan_id
      this.form.member_id = row.member_id
      this.form.disbursement_id = row.disbursement_id
      this.form.collection_center_id = row.collection_center_id
      this.form.amt = row.arrear
      this.memberloanplan = row
      this.$axios.get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
      .then((response) => response.data)
      .then((data) => {
        this.memberRecord = data.data[0]
        if (this.memberRecord) {
          this.photo = this.$store.state.imageBaseUrl + this.memberRecord.user_id + '/photo/' + this.memberRecord.photo
        }
        // console.log(data.data)
      })
      .catch(
        function (error) { console.log(error) }
      )
      this.$axios
        .get('branchledger?all=all&status=active&multiple_group_id[]=1&multiple_group_id[]=2&multiple_group_id[]=4&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.bank_accounts = data.data
          $.each(this.bank_accounts, function (key, value) {
            this.bank_accounts[key].name = value.ledger.name
            if (value.ledger.id === 3) {
              this.form.branch_ledger_id = value.id
            }
          }.bind(this))
        }).catch(function (error) { console.log(error) })
      $('#newModal').modal({backdrop: 'static', keyboard: false})
     // this.loadDisbursement()
    },
    getBranchRecord () {
      var c = JSON.parse(localStorage.user)
      var pageUrl = ''
      this.form.branch_id = this.branch.id
      this.form.collection_center_id = ''
      // this.form.planType = ''
      this.memberloanplans = []
      this.rowsMemberCollections = []
      this.form.member_loan_plan_id = ''
      this.colC = {}
      this.rows = []
      this.form.planType = 'group'
      pageUrl += 'collectioncenter?all=all'
      if (this.branch) {
        pageUrl += `&branch_id=${this.branch.id}`
      }
      if (c.role.name === 'Agent' || c.role.name === 'Field Officer') {
        pageUrl += `&agent_id=${c.id}`
      }
      this.$axios.get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.collectionCenters = data.data
          _.forEach(this.collectionCenters, function (item, key) {
            this.collectionCenters[key].name = item.name + ' (' + item.centerCode + ')'
          }.bind(this))
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      this.getPlanType()
      if (this.emiDate) {
        // this.getEMIRecord()
        this.loadAgentMember()
      } else {
        this.getMemberLoanPlan()
      }
      this.$axios
        .get('designation?all=all&status=active', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          this.designations = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    getStaff () {
      this.form.designation_id = this.designation.id
      this.$axios
        .get('staff?all=all&status=active&branch_id=' + this.form.branch_id + '&designation_id=' + this.designation.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.staffs = data.data
          _.forEach(this.staffs, function (item, key) {
            this.staffs[key].name = item.user.name + ' (' + item.user.code + ')'
          }.bind(this))
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    getAgentMembersCollection () {
      this.totalAmt = 0
      this.rowsAgentMemberRecords = []
      this.$axios
        .get('agentemi?all=all&status=unpaid&agent_id=' + this.staff.user.id + '&emiDate=' + this.emiDate, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          console.log('=========== agent wise member record =============')
          _.forEach(data.data, function (value) {
            var dd = _.find(this.rowsAgentMemberRecords, function (o) {
              return o.member_loan_plan_id === value.member_loan_plan_id
            })
            if (!dd) {
              this.rowsAgentMemberRecords.push(value)
              if (value.arrear === '' || value.arrear === null) {
                value.arrear = 0
              }
              this.totalAmt += parseInt(value.arrear)
             // alert('2')
            }
          }.bind(this))
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getMembers () {
      this.memberloanplans = []
      this.form.member_loan_plan_id = ''
      this.rows = []
      this.rowsMemberCollections = []
      this.form.collection_center_id = this.collectionCenter.id
      if (this.emiDate) {
        this.getEMIRecord()
      } else {
        this.getMemberLoanPlan()
      }
    },
    getEMIRecord () {
      this.loadAgentMember()
      this.memberloanplans = []
      this.rows = []
      this.rowsMemberCollections = []
      this.form.member_loan_plan_id = ''
      if (this.emiDate) {
        this.$axios
        .get('memberemi?all=all&emiDate=' + this.emiDate + '&branch_id=' + this.form.branch_id + '&type=' + this.form.planType + '&collection_center_id=' + this.form.collection_center_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.memberloanplans = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        this.getMemberLoanPlan()
      }
    },
    planName (plan) {
      var pln = JSON.parse(plan)
      this.form.member_loan_plan_id = null
      return pln.name
    },
    viewModal (row) {
      this.form.reset()
      $('#viewModal').modal({backdrop: 'static', keyboard: false})
      this.seeRecord = row
      this.pl = JSON.parse(row.plan)
    },
    viewGroupMember (id) {
      this.loadGroupMember(id)
      $('#viewGroupMember').modal({backdrop: 'static', keyboard: false})
      // this.viewCollectionCenter = collection_center.id
      // console.log(collection_center.id)
    },
    printView () {
      $('#printView').modal({backdrop: 'static', keyboard: false})
    },
    getSingleMemberLoanDetails () {
      if (this.emiDate) {
        this.$axios
        .get('memberemi?all=all&member_loan_plan_id=' + this.form.member_loan_plan_id + '&emiDate=' + this.emiDate, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log('record by date')
          // console.log(data.data)
          this.rows = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        this.$axios
        .get('memberemi?all=all&member_loan_plan_id=' + this.form.member_loan_plan_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log('record without date')
          // console.log(data.data)
          this.rows = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      }
      this.$axios
        .get('membercollection?all=all&member_loan_plan_id=' + this.form.member_loan_plan_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data)
          this.rowsMemberCollections = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      var ss = this.form.member_loan_plan_id
      if (this.memberloanplans.length >= 1) {
        if (!this.emiDate) {
          this.memberloanplan = _.find(this.memberloanplans, function (o) { return o.id === ss })
        }
        // console.log(this.memberloanplan)
      }
      this.form.member_id = this.memberloanplan.member_id
      this.form.disbursement_id = this.memberloanplan.disbursement_id
      if (this.form.planType === 'group') {
        if (this.form.collection_center_id === '' || this.form.collection_center_id === null) {
          this.form.collection_center_id = this.memberloanplan.collection_center_id
        }
      }
    },
    collectPayment () {
      if (this.memberloanplan.type === 'individual') {
        this.$delete(this.form, 'collection_center_id')
      }
      this.form.date = this.form.paymentDate
      this.$axios
        .post('memberattendance', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Toast.fire({
            icon: 'success',
            title: 'Attendance Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      this.$axios
        .post('membercollection', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Payment Collect Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    deleteModal (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.$axios
            .delete('collectioncentermember/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then(() => {
              Fire.$emit('AfterCreate')
              Swal.fire('Deleted!', 'Your file has been deleted.', 'success')
            })
            .catch(() => {
              Swal.fire('Failed!', 'There was something wrong.', 'error')
            })
        }
      })
    },
    getSelectPlan () {
      // alert(this.form.plan.id)
      this.form.plan_id = this.form.plan.id
    },
    getMemberLoanPlan () {
      this.$axios
        .get('memberloanplan?all=all&branch_id=' + this.form.branch_id + '&searchTerm=' + this.form.planType + '&collection_center_id=' + this.form.collection_center_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data)
          this.memberloanplans = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getLoanDetailsApplicationNumber () {
      this.form.member_loan_plan_id = []
      this.rows = []
      this.rowsMemberCollections = []
      this.$axios
      .get('memberloanplan?all=all&searchTerm=' + this.applicationNumber, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data.data)
          this.form.member_loan_plan_id = data.data[0]['id']
          this.$axios
        .get('memberloanplan?all=all/' + this.form.member_loan_plan_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // alert(data)
         // console.log('hellooo')
         // console.log(data.data)
          this.memberloanplan = data.data
          // console.log('memberloanplans' + this.memberloanplans)
          this.getSingleMemberLoanDetails()
        })
        .catch(function (error) {
          console.log(error)
        })
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getLoanDetailsMemberCode () {
      this.$axios
      .get('memberloanplan?all=all&applicationNo=' + this.memberCode, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data.data)
         // alert(data.data.data)
          this.form.member_loan_plan_id = data.data[0]['id']
          this.getSingleMemberLoanDetails()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getPlanType () {
      this.form.collection_center_id = ''
      this.form.member_loan_plan_id = ''
      this.memberloanplans = []
      this.rows = []
      this.rowsMemberCollections = []
      if (this.form.planType === 'individual') {
        this.collectionCenter = {'name': 'Select Group'}
      }
      if (this.form.planType === 'group') {
        this.$axios.get('collectioncenter?all=all&status=active&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.collectionCenters = data.data
            _.forEach(this.collectionCenters, function (item, key) {
              this.collectionCenters[key].name = item.name + ' (' + item.centerCode + ')'
              if (this.form.collection_center_id === item.id) {
                this.colC = item
              }
            }.bind(this))
          })
          .catch(
            function (error) {
              Toast.fire({ icon: 'error', title: 'Please Try Again' })
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
      }
      if (this.emiDate) {
        this.getEMIRecord()
      } else {
        this.getMemberLoanPlan()
      }
      // this.form.member_id = null
    },
    getGroupLeader () {
     // var x = this.groupMembers
    },
    getMemberAndGroupAndAgent () {
      var c = JSON.parse(localStorage.user)
      var pageUrl = ''
      this.$axios.get('member?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.members = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      if (c.role.name === 'Agent' || c.role.name === 'Field Officer') {
        pageUrl += `agent/group?all=all&agent_id=${c.agent_profile.user_id}`
      } else {
        pageUrl += 'collectioncenter?all=all'
      }
      if (this.form.branch_id) {
        pageUrl += `&branch_id=${this.form.branch_id}`
      }
      this.$axios.get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.collectionCenters = data.data
          _.forEach(this.collectionCenters, function (item, key) {
            this.collectionCenters[key].name = item.name + ' (' + item.centerCode + ')'
            if (this.form.collection_center_id === item.id) {
              this.colC = item
            }
          }.bind(this))
          // this.branch = data.data[0].branch
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )

      this.$axios
        .get('staff?all=all&status=active&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.staffs = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadLoan () {
      this.$axios.get('loanplan?all=all&status=true', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.loanplans = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadGroupMember (id) {
      this.$axios
        .get('collectioncentermember?all=all&collection_center_id=' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.groupMembers = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadAgentMember () {
      var c = JSON.parse(localStorage.user)
      this.rowsAgentMemberRecords = []
      this.totalAmt = 0
      let colCId = ''
      if (this.colC.id) {
        // alert('hello')
        colCId = this.colC.id
      }
      if (c.role.name === 'Agent' || c.role.name === 'Field Officer') {
        this.$axios
        .get('agent/group?agent_id=' + c.agent_profile.user_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.collectionCenters = data.data
          _.forEach(this.collectionCenters, function (item, key) {
            this.collectionCenters[key].name = item.name + ' (' + item.centerCode + ')'
          }.bind(this))
        })
        .catch(function (error) {
          console.log(error)
        })
      }
      if (c.type === 'admin') {
        this.$axios
        .get('adminemi?all=all&type=group&status=unpaid&emiDate=' + this.emiDate + '&branch_id=' + this.form.branch_id + '&collection_center_id=' + colCId, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log('=========== admin wise member record =============')
          this.rowsAgentMemberRecords = data.data
          this.totalAmt = _.sumBy(this.rowsAgentMemberRecords, function (o) { return o.arrear })
          console.log('data data')
        })
        .catch(function (error) {
          console.log(error)
        })
      }
      if (c.type === 'staff') {
        // this.form.branch_id = c.agent_profile.branch_id
        var pageUrl = ''
        pageUrl += 'agentemi?all=all&status=unpaid&type=group'
        if (this.form.branch_id) {
          pageUrl += `&branch_id=${this.form.branch_id}`
        }
        if (c.role.name === 'Agent' || c.role.name === 'Field Officer') {
          pageUrl += `&agent_id=${c.id}`
        }
        if (this.emiDate) {
          pageUrl += `&emiDate=${this.emiDate}`
        }
        if (colCId) {
          pageUrl += `&collection_center_id=${colCId}`
        }
        this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log('=========== agent wise member record =============')
          _.forEach(data.data, function (value) {
            var dd = _.find(this.rowsAgentMemberRecords, function (o) {
              return o.member_loan_plan_id === value.member_loan_plan_id
            })
            if (!dd) {
              this.rowsAgentMemberRecords.push(value)
              if (value.arrear === '' || value.arrear === null) {
                value.arrear = 0
              }
              this.totalAmt += parseInt(value.arrear)
             // alert('2')
            }
          }.bind(this))
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    },
    loadCompanyProfile () {
      let loader = this.$loading.show()
      this.$axios
        .get('settings', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.getCompanyRecord = data
          if (this.getCompanyRecord.logo != null) {
            this.logo = this.$store.state.imageBaseUrl + 'logo/' + this.getCompanyRecord.logo
          } else {
            alert('hello')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    printAgentCollectionList () {
      // Get HTML to print from element
      const prtHtml = document.getElementById('printAgentCollectionList').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/3.4/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
              ${stylesHtml}
              <style>
                table {border-width:2px; color:black; border-style:solid;}
              </style>
          </head>
          <body>
              ${prtHtml}
          </body>
        </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    },
    loadDisbursement () {
      this.$axios
        .get('disbursement?all=all&status=disbursed', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.loadDisbursements = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },

  created () {
    // this.loadMember();
    var c = JSON.parse(localStorage.user)
    if (c.type === 'staff') {
      this.form.branch_id = c.agent_profile.branch_id
      this.getMemberAndGroupAndAgent()
    }
    this.loadAgentMember()
    this.getBranch()
    this.loadLoan()
    this.loadCompanyProfile()
    Fire.$on('AfterCreate', () => {
      this.loadAgentMember()
      this.getSingleMemberLoanDetails()
    })
  }
}
</script>
<style scoped>
  table.vgt-table tbody td {
    font-size: 8px !important;
  }
</style>



// WEBPACK FOOTER //
// GroupEMICollection.vue?140540f9